import { PaymentsAPIService } from '@weave/schema-gen-ts/dist/schemas/payments/v2/payments_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaPaymentsV2Service = bindHTTP(PaymentsAPIService);
export const serviceName = 'payments-v2' as const;
